import { useAuth } from "@/context/AuthContext";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const AdminGate = () => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-espresso">
        <span className="h-2 w-2 rotate-45 animate-pulse bg-gold" />
      </div>
    );
  }
  if (user === false) return <AdminLogin />;
  return <AdminDashboard />;
};

export default AdminGate;
